<div class="container mobile-container container-space">
  <div class="col-12 btn-account d-flex align-items-center justify-content-between">
         <span>
           <img src="/icons/info-circle-solid.svg">
           {{ 'AboutUs' | translate }}
         </span>
    <div class="btn-back d-lg-none d-block">
        <span (click)="openBackClicked()">
         {{ 'Back' | translate }}
          <img src="/icons/forward-outline.svg">
        </span>
    </div>
  </div>
  <div [innerHTML]="domSanitizer.bypassSecurityTrustHtml(Config.branch.Details.AboutUs)"></div>
</div>
